// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Redesign / compliance section indentation ── */
.redesign-section {
    padding-left: 16px;
    border-left: 3px solid #dee2e6;
    margin-bottom: 8px;
}

.compliance-section {
    padding-left: 24px;
    margin-top: 4px;
}

.reason-group {
    display: flex;
    flex-direction: column;
}

.reason-row {
    margin-bottom: 4px;
}

.compliance-test-label {
    cursor: pointer;
    font-weight: normal;
    gap: 6px;
}

/* ── Content ── */
mat-dialog-content {
    padding: 2px 24px !important;
    background-color: #f0f0f0;
}

.content {
    padding: 16px;
    border-radius: 4px;
}

/* ── Actions ── */
mat-dialog-actions {
    background-color: #f0f0f0;
    padding: 8px 24px !important;
}

.button-gap {
    gap: 12px;
}

/* ── Radio button label vertical alignment ── */
::ng-deep .mat-mdc-radio-button .mdc-form-field {
    align-items: center;
}

::ng-deep .mdc-label {
    margin-top: 7px;
}

/* ── Well type radio button color override ── */
::ng-deep .well-type-radio .mdc-radio__outer-circle,
::ng-deep .well-type-radio .mdc-radio__inner-circle {
    border-color: #0066B2 !important;
}

::ng-deep .well-type-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {
    border-color: #0066B2 !important;
}

::ng-deep .well-type-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {
    background-color: #0066B2 !important;
}

::ng-deep .well-type-radio .mdc-radio__background::before {
    background-color: #0066B2 !important;
}

/* ── Reason radio button color override ── */
::ng-deep .reason-radio .mdc-radio__outer-circle,
::ng-deep .reason-radio .mdc-radio__inner-circle {
    border-color: #0066B2 !important;
}

::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {
    border-color: #0066B2 !important;
}

::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {
    background-color: #0066B2 !important;
}

::ng-deep .reason-radio .mdc-radio__background::before {
    background-color: #0066B2 !important;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/create-new-part-dialog/create-new-part-dialog.component.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,kBAAkB;AAClB;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA,gDAAgD;AAChD;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,gDAAgD;AAChD;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,6CAA6C;AAC7C;;IAEI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["/* ── Redesign / compliance section indentation ── */\n.redesign-section {\n    padding-left: 16px;\n    border-left: 3px solid #dee2e6;\n    margin-bottom: 8px;\n}\n\n.compliance-section {\n    padding-left: 24px;\n    margin-top: 4px;\n}\n\n.reason-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.reason-row {\n    margin-bottom: 4px;\n}\n\n.compliance-test-label {\n    cursor: pointer;\n    font-weight: normal;\n    gap: 6px;\n}\n\n/* ── Content ── */\nmat-dialog-content {\n    padding: 2px 24px !important;\n    background-color: #f0f0f0;\n}\n\n.content {\n    padding: 16px;\n    border-radius: 4px;\n}\n\n/* ── Actions ── */\nmat-dialog-actions {\n    background-color: #f0f0f0;\n    padding: 8px 24px !important;\n}\n\n.button-gap {\n    gap: 12px;\n}\n\n/* ── Radio button label vertical alignment ── */\n::ng-deep .mat-mdc-radio-button .mdc-form-field {\n    align-items: center;\n}\n\n::ng-deep .mdc-label {\n    margin-top: 7px;\n}\n\n/* ── Well type radio button color override ── */\n::ng-deep .well-type-radio .mdc-radio__outer-circle,\n::ng-deep .well-type-radio .mdc-radio__inner-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .well-type-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .well-type-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {\n    background-color: #0066B2 !important;\n}\n\n::ng-deep .well-type-radio .mdc-radio__background::before {\n    background-color: #0066B2 !important;\n}\n\n/* ── Reason radio button color override ── */\n::ng-deep .reason-radio .mdc-radio__outer-circle,\n::ng-deep .reason-radio .mdc-radio__inner-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__outer-circle {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio.mat-mdc-radio-checked .mdc-radio__inner-circle {\n    background-color: #0066B2 !important;\n}\n\n::ng-deep .reason-radio .mdc-radio__background::before {\n    background-color: #0066B2 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
